// Shared "this isn't live yet" treatment for the context-panel views (Assistant / Action
// items / Insights) — see each component's file header and lib/featureFlags.ts for why.
// Two pieces, used together by each panel:
//   - `PreviewDataLabel`: a small badge sitting on top of placeholder content, shown only
//     when `VITE_FEATURE_PANELS=1` is on (opt-in preview of what the wiring will look like).
//   - `ComingSoonPanel`: the default (flag-off) collapsed state — no fabricated content,
//     just an honest "not built yet" message.
import { ClockIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

export const COMING_SOON_LABEL = 'Coming soon — preview data, not live';

export function PreviewDataLabel() {
  return <span className="preview-data-label">{COMING_SOON_LABEL}</span>;
}

export function ComingSoonPanel({
  icon,
  title,
  description,
}: {
  icon: ReactNode;
  title: string;
  description: string;
}) {
  return (
    <div className="coming-soon-panel">
      <span className="coming-soon-icon" aria-hidden="true">
        {icon}
      </span>
      <div className="coming-soon-title">{title}</div>
      <p className="coming-soon-text">{description}</p>
      <span className="coming-soon-badge">
        <ClockIcon width={12} height={12} aria-hidden="true" />
        Coming soon
      </span>
    </div>
  );
}
